<script>
  //   import {
  //     design,
  //     events,
  //     sports,
  //     sportsSimple,
  //     workwear,
  //   } from "../../utils/menulinks";
  import { fade } from 'svelte/transition';

  //   import MegaMenuLinks from "./MegaMenuLinks.svelte";
  //   import SearchBar from "../SearchBar.svelte";
  import DropdownMenuMobile from './DropdownMenuMobile.svelte';

  export let show = false;
  export let productCategories;
  export let sportsCollections;
  export let workCollections;
  export let schoolCollections;
  export let eventCollections;

  let showSportlink = false;
  let showWorklink = false;
  let showSchoollink = false;
  let showEventslink = false;
  let showDesignlink = false;
  let showProductsLink = false;

  function closeMenu() {
    show = false;
  }

  function linkClick(e) {
    closeMenu();
  }

  $: toggleScrollbar(show);

  function toggleScrollbar() {
    if (!process.browser) return;
    if (screenLargerThan('800px')) return;

    if (show) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'auto';
    }
  }

  function screenLargerThan(width) {
    return window.matchMedia(`(min-width: ${width})`).matches;
  }
</script>

{#if show}
  <div class="nav" transition:fade>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="close" on:click={closeMenu}>&times;</div>
    <!-- {#if !screenLargerThan("800px")}
      <SearchBar />
    {/if} -->
    <ul>
      <li>
        <div class="link">
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <span on:click={() => (showProductsLink = !showProductsLink)}
            >Products<img src="img/icons/triangle.svg" alt="" />
          </span>
        </div>
        <DropdownMenuMobile category={'products'} items={productCategories} bind:show={showProductsLink} />
      </li>
      <li>
        <div class="link">
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <span on:click={() => (showSportlink = !showSportlink)}
            >Sports<img src="img/icons/triangle.svg" alt="" />
          </span>
        </div>
        <DropdownMenuMobile category={'sports'} items={sportsCollections} bind:show={showSportlink} />
      </li>
      <li>
        <div class="link">
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <span on:click={() => (showWorklink = !showWorklink)}>Work<img src="img/icons/triangle.svg" alt="" /> </span>
        </div>
        <DropdownMenuMobile category={'work'} items={workCollections} bind:show={showWorklink} />
      </li>
      <li>
        <div class="link">
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <span on:click={() => (showSchoollink = !showSchoollink)}
            >School<img src="img/icons/triangle.svg" alt="" />
          </span>
        </div>
        <DropdownMenuMobile category={'school'} items={schoolCollections} bind:show={showSchoollink} />
      </li>
      <li>
        <div class="link">
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <span on:click={() => (showEventslink = !showEventslink)}
            >Events<img src="img/icons/triangle.svg" alt="" />
          </span>
        </div>
        <DropdownMenuMobile category={'events'} items={eventCollections} bind:show={showEventslink} />
      </li>
    </ul>
    <ul>
      <li><a href="/cart" on:click={linkClick}>Your Cart</a></li>
      <!-- <li><a href="/" on:click={linkClick}>Login</a></li>
      <li><a href="/" on:click={linkClick}>Signup</a></li> -->
    </ul>
    <ul class="show-all">
      <!-- <li><a href="/about" on:click={linkClick}>About</a></li> -->
      <li><a href="/faqs" on:click={linkClick}>FAQ</a></li>
      <li><a href="/contact" on:click={linkClick}>Contact Us</a></li>
      <!-- <li><a href="/blog">Blog</a></li> -->
    </ul>
  </div>
{/if}

<style>
  .nav {
    display: block;
    z-index: 50;
    background-color: #000;
    position: absolute;
    width: 100%;
    top: 0;
    right: 0;
    color: #fff;
    padding: 2.5rem;
    padding-bottom: 5rem;
    overflow-y: auto;
    cursor: default;
  }

  .close {
    font-size: 5rem;
    font: 'Inter', sans-serif;
    font-weight: 300;
    position: fixed;
    top: 0;
    right: 2rem;
    cursor: pointer;
  }

  ul {
    list-style: none;
    margin-top: 4rem;
  }

  ul > li:not(:first-child) {
    margin-top: 1.5rem;
  }

  li {
    position: relative;
  }

  li > * {
    margin-top: 2rem;
  }

  .link {
    display: flex;
    align-items: center;
  }

  .link > span {
    font-size: 2rem;
    display: flex;
    align-items: center;
  }

  a {
    text-decoration: none;
    color: #fff;
    font-size: 2rem;
  }

  a:hover {
    color: #ddd;
  }

  @media screen and (min-width: 800px) {
    .nav {
      top: 6.8rem;
      right: 0;
      width: 40rem;
      height: auto;
    }

    ul {
      display: none;
    }

    ul.show-all {
      display: block;
    }

    .close {
      display: none;
    }
  }
</style>
